import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Link as LinkLi } from '@material-ui/core';
import { getAuthDetails } from 'globalutils/fmUtils';
import { headerNames } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const Header = ({ dashboard, i18n, headerText, Styled }) => {
  const list = checkServiceProvider('header_list', window.$environment.SERVICE_PROVIDER, false, {
    comSummaryItems: dashboard?.data?.companySummary?.items || [],
  });

  const auth = getAuthDetails();

  return (
    <>
      {auth?.subscriptions?.wCompanySummary ? (
        <>
          <Styled.SummarySection>{list && <p className="spireonOnly"> {i18n.t('common.summary')}</p>}</Styled.SummarySection>
          <Styled.HeaderWrapper>
            {list && (
              <>
                {headerText && <p className="clutchOnly"> {i18n.t(headerText)}:</p>}
                {list?.map((item, index) => {
                  item.name = headerNames[item.itemType];
                  return headerNames[item.itemType] && <Item item={item} key={`${item.name}${index}`} />;
                })}
              </>
            )}
          </Styled.HeaderWrapper>
        </>
      ) : (
        <div className="notSubscriped"></div>
      )}
    </>
  );
};

const Item = ({ item }) => {
  return (
    <li>
      {item.hasLink ? (
        <LinkLi component={Link} to={item.link}>
          <div className={item.itemType === 'TOTALDRIVERS' || item.itemType === 'TOTALTRUCKS' ? 'totalAmount' : ''}>
            {item.name}
          </div>
          <div className={item.itemType === 'TOTALDRIVERS' || item.itemType === 'TOTALTRUCKS' ? 'total' : ''}>{item.count}</div>
        </LinkLi>
      ) : (
        <>
          <div>{item.name}</div> <div className="noLink">{item.count}</div>
        </>
      )}
    </li>
  );
};

Item.defaultTypes = {
  drivers: {},
  regions: {},
};
Item.propTypes = {
  item: PropTypes.object.isRequired,
};

Header.defaultProps = {
  headerText: '',
  data: [],
};
Header.propTypes = {
  headerText: PropTypes.string,
  data: PropTypes.array,
};
export default Header;
